export default __webpack_public_path__ + "static/media/vector-creator2.93c5567b.png";